<div class="pagination">
  <div>
    <div *ngIf="pageSizeVisible">
      <dx-select-box
                [dataSource]="numberEntriesPage"
                [width]="80"
                [height]="40"
                [(value)]="pageSize"
                (onValueChanged)="onChangePageSize()"
              >
     </dx-select-box>
    </div>
    
  </div>
  

  <div class="flexContent8 ai-c">
      <i class="left" [ngClass]="{'opacity' : currentPage == 1}" (click)="onDecrease()"></i>

      <dx-number-box
        [(value)]="currentPage"
        [min]="1"
        [max]="totalPages"
        width="48px"
        (onValueChanged)="valueChange()"
      ></dx-number-box>

      <span style="opacity:0.6">{{ 'general.of' | translate }}</span>

      {{totalPages}}

      <i class="right" [ngClass]="{'opacity' : currentPage == totalPages}" (click)="onIncrease()"></i>
  </div>
 
</div>
